import { parseServiceSchedule, SHOWN_TAGS } from '@common'
import { INVENTORY_STATUS } from 'common/enums'

export const formatFilteredMenus = menus => {
    return menus.map(product => {
        return {
            ...product,
            shownTags: product.tags.filter(tag => SHOWN_TAGS.includes(tag)),
        }
    })
}

export const organizeMenus = menus => {
    const orderedCategories = Array.from(new Set(menus.map(menu => menu.stallName)))

    const processedMenus = menus.map(menu => {
        // Check if all variants are sold out
        const isAllVariantSoldOut = menu.variants.every(
            variant => variant.inventory?.status === INVENTORY_STATUS.SOLD_OUT
            // (variant.inventory?.initialQuantity !== null &&
            //     variant.inventory?.initialQuantity <= variant.inventory?.orderedQuantity)
        )

        // Parse service schedule
        const { isService, servingTimes } = parseServiceSchedule(menu.openTimes)

        // get lowest price from all variants
        const prices = menu.variants.map(v => v.sellPrice).filter(price => price > 0)
        const lowestPrice = Math.min(...prices)

        return {
            ...menu,
            isAllVariantSoldOut,
            isService,
            servingTimes,
            lowestPrice,
        }
    })

    // Split menus into available and unavailable
    const { availableMenus, unavailableMenus } = processedMenus.reduce(
        (acc, menu) => {
            if (!menu.isService || menu.isAllVariantSoldOut) {
                acc.unavailableMenus.push(menu)
            } else {
                acc.availableMenus.push(menu)
            }
            return acc
        },
        { availableMenus: [], unavailableMenus: [] }
    )

    const filteredMenus = orderedCategories.map(category => ({
        category,
        items: [],
    }))

    // Add unavailable category at the end if there are any unavailable items
    if (unavailableMenus.length > 0) {
        filteredMenus.push({
            category: 'Unavailable Items',
            items: [],
        })
    }

    // First add all available items to their original categories
    availableMenus.forEach(menu => {
        const categoryIdx = filteredMenus.findIndex(m => m.category === menu.stallName)
        if (categoryIdx !== -1) {
            filteredMenus[categoryIdx].items.push(menu)
        }
    })

    // Then add all unavailable items to the special category
    if (unavailableMenus.length > 0) {
        const lastIndex = filteredMenus.length - 1
        filteredMenus[lastIndex].items = unavailableMenus
    }

    return {
        // categories: [...orderedCategories, ...(unavailableMenus.length > 0 ? ['Unavailable Items'] : [])],
        categories: orderedCategories,
        filteredMenus,
    }
}
